import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { asyncScheduler, of } from 'rxjs';
import { catchError, debounceTime, map, switchMap, } from 'rxjs/operators';

import * as VoucherActions from '../actions/voucher.actions';
import { VouchersService } from '../../services/vouchers.service';
import { Voucher } from '../../interfaces/voucher';

@Injectable()
export class VoucherEffects {
  retrieveVouchers$ = createEffect(({ debounce = 1000, scheduler = asyncScheduler } = {}) =>
    this.actions$.pipe(
      ofType(VoucherActions.retrieve),
      debounceTime(debounce, scheduler),
      switchMap(() => this.vouchersService.getVouchers().pipe(
        map((vouchers: Voucher[]) =>
          VoucherActions.retrieveSuccess({vouchers})
        ),
        catchError((error) =>
          of(VoucherActions.retrieveFailure({error}))
        )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private vouchersService: VouchersService
  ) {}
}
